export default "__VITE_ASSET__D4XG9eFw__"